import { createSelector } from '@reduxjs/toolkit';

import { selectIsLiveChat } from '../../../common/selectors/chat';
import { selectFieldState } from '../../../common/selectors/field';

export const selectIsHidden = createSelector(
  [selectFieldState, selectIsLiveChat],
  ({ hidden }, isLiveChat) => hidden && !isLiveChat,
);
